import { useGetGroupsQuery } from "@/store/services/supabase";
import { PortfolioExportJobSchema } from "@/tools/aggregate/portfolio-export/types";
import { useCanCreatePrivatePortfolio } from "@/utils/hooks/useCanCreatePrivate";
import { Input, Modal } from "antd";
import type { MutableRefObject, ReactNode } from "react";
import { useState } from "react";
import { GridItem, PortfolioExportPermissions } from "./PortfolioExportFormItems";
export type OnEditProps = {
  schema: PortfolioExportJobSchema;
  name: string;
  isPrivate: boolean;
  groupId: string;
};
export interface EditJobModalProps {
  schema: PortfolioExportJobSchema;
  isOwner: boolean;
  open: boolean;
  onCancel: () => void;
  onOk: (props: OnEditProps) => Promise<void>;
  hasOrgKeys: boolean;
  editModalRef?: MutableRefObject<null>;
}

/**
 * Edit-job modal content. Accepts editModalRef so callers (Context or JobActions) can inject it
 * without this file depending on PortfolioTutorialContext.
 */
export const EditJobModal = ({
  schema,
  isOwner,
  open,
  onCancel,
  onOk,
  hasOrgKeys,
  editModalRef = {
    current: null
  }
}: EditJobModalProps) => {
  const canCreatePrivate = useCanCreatePrivatePortfolio();
  const {
    data: groups
  } = useGetGroupsQuery();
  const [name, setName] = useState(schema.name);
  const [isPrivate, setIsPrivate] = useState(schema.isPrivate || false);
  const [groupId, setGroupId] = useState(schema.groupId);
  if (!groups) return null;
  const groupOpts = groups.map(g => ({
    key: g.id,
    value: g.id,
    label: g.name || ""
  })).filter(val => isOwner ? true : val.key === schema.groupId);
  const handleOk = async () => {
    await onOk({
      schema,
      groupId,
      name,
      isPrivate
    }).then(onCancel);
  };
  return <Modal title={`Edit ${schema.name}`} open={open} onCancel={onCancel} onOk={handleOk} okText="Save" modalRender={(node: ReactNode) => <div ref={editModalRef as MutableRefObject<null>}>{node}</div>} data-sentry-element="Modal" data-sentry-component="EditJobModal" data-sentry-source-file="PortfolioExportEditJobModal.tsx">
      <div className="flex flex-col gap-2 rounded-lg border border-subtle p-4">
        <GridItem data-sentry-element="GridItem" data-sentry-source-file="PortfolioExportEditJobModal.tsx">
          <div>Name</div>
          <div className="col-span-2">
            <Input value={name} className="col-span-2" onChange={val => setName(val.target.value)} data-sentry-element="Input" data-sentry-source-file="PortfolioExportEditJobModal.tsx" />
          </div>
        </GridItem>

        <PortfolioExportPermissions isPrivate={isPrivate} setIsPrivate={setIsPrivate} enableShare={!!hasOrgKeys} groupOpts={groupOpts} groupId={groupId} setGroupId={setGroupId}
      // Allow getting out of private even when private disabled.
      hidePermissionsRadioGroup={!canCreatePrivate && !schema.isPrivate} data-sentry-element="PortfolioExportPermissions" data-sentry-source-file="PortfolioExportEditJobModal.tsx" />
      </div>
    </Modal>;
};